<template>
    <el-form ref="form" label-position="top" v-loading="getScreenSize < 2 && !delayedLoading[7]"  element-loading-text="Loading...">
        <el-row :gutter="25">
            <el-col :lg="12" v-if="$p('settings/FTPSending/address') && (getScreenSize > 1 || delayedLoading[1])">
                <el-form-item class="el-form-item-full" :label="$l('settings/FTPSending/FTP Address')">
                    <el-input :disabled="getSettingsAddons.ftp == '0'" v-model="getSettingsFTPSending.address"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="12" v-if="$p('settings/FTPSending/refresh') && (getScreenSize > 1 || delayedLoading[2])">
                <el-form-item class="el-form-item-full" :label="$l('settings/FTPSending/Refresh Rate')">
                    <el-select :disabled="getSettingsAddons.ftp == '0'" v-model="getSettingsFTPSending.refresh" :placeholder="$l('common/select')">
                        <el-option :label="$l('settings/FTPSending/Disable')" value="0"></el-option>
                        <el-option :label="'1 ' + $l('settings/FTPSending/sec')" value="1"></el-option>
                        <el-option :label="'5 ' + $l('settings/FTPSending/sec')" value="5"></el-option>
                        <el-option :label="'1 ' + $l('settings/FTPSending/min')" value="60"></el-option>
                        <el-option :label="'5 ' + $l('settings/FTPSending/min')" value="300"></el-option>
                        <el-option :label="'10 ' + $l('settings/FTPSending/min')" value="600"></el-option>
                        <el-option :label="'15 ' + $l('settings/FTPSending/min')" value="900"></el-option>
                        <el-option :label="'1 '+ $l('settings/FTPSending/hour')" value="3600"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col v-show="getSettingsAddons.ftp == '1'" :lg="12" v-if="$p('settings/FTPSending/username') && (getScreenSize > 1 || delayedLoading[3])">
                <el-form-item class="el-form-item-full"  :label="$l('settings/FTPSending/Username')">
                    <el-input v-model="getSettingsFTPSending.user"></el-input>
                </el-form-item>
            </el-col>
            <el-col v-show="getSettingsAddons.ftp == '1'" :lg="12" v-if="$p('settings/FTPSending/password') && (getScreenSize > 1 || delayedLoading[4])">
                <el-form-item class="el-form-item-full"  :label="$l('settings/FTPSending/Password')">
                    <el-input :type="showPassword?'':'password'" v-model="getSettingsFTPSending.password">
                        <el-button @click="showPassword=!showPassword" class="show-password-button" slot="append"><icon name="eye"> </icon></el-button>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col v-show="getSettingsAddons.ftp == '1'" :lg="12" v-if="$p('settings/FTPSending/port') && (getScreenSize > 1 || delayedLoading[5])">
                <el-form-item class="el-form-item-full"  :label="$l('settings/FTPSending/Port')">
                    <el-input v-model="getSettingsFTPSending.port"></el-input>
                </el-form-item>
            </el-col>
            <el-col v-show="getSettingsAddons.ftp == '1'" :lg="12" v-if="$p('settings/FTPSending/port') && (getScreenSize > 1 || delayedLoading[6])">
                <el-form-item class="el-form-item-full" label=" ">
                    <el-button :loading="testButtonLoading" @click="testButtonClicked" class="test-button" type="primary">Test</el-button>
                </el-form-item>
            </el-col>
            <el-col>
            </el-col>
            <el-col v-show="getSettingsAddons.ftp == '1'" :lg="12" v-if="$p('settings/FTPSending/zipped') && (getScreenSize > 1 || delayedLoading[7])">
                <el-form-item class="el-form-item-full"  :label="$l('settings/download/Compression')">
                    <el-select v-model="getSettingsFTPSending.zip" :placeholder="$l('common/select')">
                        <el-option :label="$l('settings/download/No compression')" :value="'0'"></el-option>
                        <el-option :label="$l('settings/download/Zip compression')" :value="'1'"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
              
        </el-row>
        <el-collapse accordion v-if="$p('settings/FTPSending/values') && (getScreenSize > 1 || delayedLoading[7])">
            <el-collapse-item :title="$l('settings/FTPSending/Values')">
                <el-row>
                    <el-col v-for="item in getSettingsFTPSending.valsel" v-bind:key="item.name" :md="12" :lg="8"><el-form-item :label="$l('settings/FTPSending/' + item.name)"><el-switch on-text="" off-text="" v-model="item.enabled"></el-switch></el-form-item></el-col>
                    <!--<el-col :md="12" :lg="8"><el-form-item label="GlobalValues"> <el-switch on-text="" off-text="" v-model="getSettingsFTPSending.valuesValues['integ']"></el-switch> </el-form-item></el-col>
                    <el-col :md="12" :lg="8"><el-form-item label="Audio"> <el-switch on-text="" off-text="" v-model="getSettingsFTPSending.valuesValues['audio']"></el-switch> </el-form-item></el-col>
                    <el-col :md="12" :lg="8"><el-form-item label="RAW Measurements"> <el-switch on-text="" off-text="" v-model="getSettingsFTPSending.valuesValues['tsv']"></el-switch> </el-form-item></el-col>
                    <el-col :md="12" :lg="8"><el-form-item label="Weather"> <el-switch on-text="" off-text="" v-model="getSettingsFTPSending.valuesValues['Weather']"></el-switch> </el-form-item></el-col>-->
                </el-row>
            </el-collapse-item>
        </el-collapse>
    </el-form>
    
</template>

<style scoped>
    .test-button{
        float:right;
        margin-top: 3px;
    }
</style>

<script>
import {mapGetters} from 'vuex'
import {ftpTestConn} from '@/store/actions'

export default {
    data() {
        return {
            testButtonLoading: false,
            delayedLoading:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},
            showPassword :false,
        }
    },
    computed:{
        ...mapGetters([
            'getSettingsFTPSending',
            'getSettingsAddons',
            'getScreenSize'
        ])
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        },
        testButtonClicked(){
            this.testButtonLoading = true;
            if (this.getSettingsFTPSending.address != "") {
                ftpTestConn(this,this.getSettingsFTPSending.address+":"+this.getSettingsFTPSending.port,"upwd",this.getSettingsFTPSending.user,this.getSettingsFTPSending.password)
                .then(data=>{
                    if (data.data.indexOf("Connection OK") > -1) {
                         this.$message({
                            type:'success',
                            message: data.data
                        });
                    } else {
                        this.$message({
                            type:'error',
                            message: data.data
                        });
                    }
                    this.testButtonLoading = false;
                })
            } else {
                this.$message({
                    type:'error',
                    message:  this.$l('settings/FTPSending/FTP Address')
                });
                this.testButtonLoading = false;
            }
        }
    },
    mounted: function(){
         setTimeout(()=>{
            var counter = 0;
            var delayedLoadingInterval = setInterval(()=>{
                this.delayedLoading[counter] = true;
                counter++;
                if(counter > 7) 
                    clearInterval(delayedLoadingInterval);
            },0);
        },500)
    }
}
</script>


// WEBPACK FOOTER //
// FTPSending.vue?572bf3a1